import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { TextBox } from '@syncfusion/ej2-inputs';



export const /** @type {?} */ inputs: string[] = ['autocomplete','cssClass','enablePersistence','enableRtl','enabled','floatLabelType','htmlAttributes','locale','multiline','placeholder','readonly','showClearButton','type','value','width'];
export const /** @type {?} */ outputs: string[] = ['blur','change','created','destroyed','focus','input','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * Represents the EJ2 Angular TextBox Component.
 * ```html
 * <ejs-textbox [value]='value'></ejs-textbox>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class TextBoxComponent extends TextBox implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-textbox',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextBoxComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function TextBoxComponent_tsickle_Closure_declarations() {
/** @type {?} */
TextBoxComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TextBoxComponent.ctorParameters;
/** @type {?} */
TextBoxComponent.prototype.formCompContext;
/** @type {?} */
TextBoxComponent.prototype.formContext;
/** @type {?} */
TextBoxComponent.prototype.tagObjects;
/** @type {?} */
TextBoxComponent.prototype.valueChange;
/** @type {?} */
TextBoxComponent.prototype.skipFromEvent;
/** @type {?} */
TextBoxComponent.prototype.registerEvents;
/** @type {?} */
TextBoxComponent.prototype.addTwoWay;
/** @type {?} */
TextBoxComponent.prototype.ngEle;
/** @type {?} */
TextBoxComponent.prototype.srenderer;
/** @type {?} */
TextBoxComponent.prototype.viewContainerRef;
/** @type {?} */
TextBoxComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
